module.exports = __webpack_public_path__ + "static/media/group-8@3x.da9cdbc6.png";